import { NgModule }             from '@angular/core';
import { RouterModule, Routes , ExtraOptions } from '@angular/router';

// Page Component
import { HomeComponent }  from './component/home/home.component';
import { SearchComponent }  from './component/search/search.component';
import { AreaComponent }  from './component/area/area.component';
import { SortComponent }  from './component/sort/sort.component';
import { ActivityComponent }  from './component/activity/activity.component';
import { ActivityListComponent }  from './component/activity/activitylist.component';
//Member Component
import { SignupComponent }  from './component/member/signup.component';
import { SignTimeComponent }  from './component/member/signTime.component';
import { SignCheckComponent }  from './component/member/signCheck.component';
import { ContactComponent }  from './component/member/contact.component';
import { ContactEditComponent }  from './component/member/contactEdit.component';
import { SignSuccessComponent }  from './component/member/signSuccess.component';
import { ReserveComponent }  from './component/member/reserve.component';
import { MybuyerComponent }  from './component/member/mybuyer.component';
import { HistoryComponent }  from './component/member/history.component';

import { ErrorComponent }  from './component/basepage/error.component';
import { NotFoundComponent }  from './component/basepage/notFound.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  // {
  //   path: '',
  //   component: LayoutComponent,
  //   data: {
  //     title: 'Home'
  //   },
  {
    path: 'home',
    component: HomeComponent,
    data:{animation:'fader'}
  },
  {
    path: 'search',
    component: SearchComponent,
    data:{animation:'fader'}
  },
  {
    path: 'area',
    component: AreaComponent,
    data:{animation:'fader'}
  },
  {
    path: 'activity/:id',
    component: ActivityComponent,
    data:{animation:'fader'}
  },
  {
    path: 'activitylist',
    component: ActivityListComponent,
    data:{animation:'fader'}
  },
  {
    path: 'sort',
    component: SortComponent,
    data:{animation:'fader'}
  },
  {
    path: 'member',
    data:{animation:'fader'},
    children: [
      { path: 'signup', component: SignupComponent,data:{animation:'fader'} },
      { path: 'signCheck/:id', component: SignCheckComponent,data:{animation:'fader'} },
      { path: 'signTime/:id', component: SignTimeComponent,data:{animation:'fader'} },
      { path: 'contact', component: ContactComponent,data:{animation:'fader'} },
      { path: 'edit', component: ContactEditComponent,data:{animation:'fader'} },
      { path: 'signSuccess', component: SignSuccessComponent,data:{animation:'fader'} },
      { path: 'reserve', component: ReserveComponent,data:{animation:'fader'} },
      { path: 'mybuyer', component: MybuyerComponent,data:{animation:'fader'} },
      { path: 'history', component: HistoryComponent,data:{animation:'fader'} }
    ]
  },
  {
    path: 'notfound',
    component: NotFoundComponent,
    data:{animation:'fader'}
  },
  {
    path: '**',
    component: ErrorComponent,
    data:{animation:'fader'}
  }
];
const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled'
};

@NgModule({
  imports: [ RouterModule.forRoot(routes,routerOptions)],
  exports: [ RouterModule ]
})
export class AppRoutingModule { }
